import { render, staticRenderFns } from "./LandSalesReport.vue?vue&type=template&id=071d2db2&"
import script from "./LandSalesReport.vue?vue&type=script&lang=js&"
export * from "./LandSalesReport.vue?vue&type=script&lang=js&"
import style0 from "./LandSalesReport.vue?vue&type=style&index=0&id=071d2db2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports